import { Component } from '@angular/core';

@Component({
  selector: 'm-not-found',
  templateUrl: './m-not-found.component.html'
})
export class MNotFoundComponent {}
